<template>
  <div class="weather">
    <ep-title style="margin-bottom:30px" title="重污染天气应急预案">
    </ep-title>
    <div class="header" style="margin-bottom:20px">备案流程</div>
    <ep-steps style="margin-bottom:20px">
      <ep-step step="1" icon="icon-shangbaodanwei">选择上报单位</ep-step>
      <ep-step step="2" icon="icon-yuanxinxi">填写预案信息</ep-step>
      <ep-step step="3" icon="icon-shangchuan">上传备案文件</ep-step>
      <ep-step step="4" icon="icon-shenhe">审核</ep-step>
      <ep-step step="5" icon="icon-wancheng">备案成功</ep-step>
    </ep-steps>
      <el-button type="primary" @click="comfirmButtype">进入备案 </el-button>
    <div class="header header-top" style="margin-bottom:20px">备案规定</div>
    <el-table :data="fileList" border style="width: 100%;margin-bottom:30px">
      <el-table-column prop="fileDes" header-align="center" align="center" label="文件">
      </el-table-column>
      <el-table-column header-align="center" align="center" label="下载" width="180">
        <template slot-scope="scope">
           <img src="./../../../static/img/xz.png" height="16" width="16" @click="getFile(scope.row.id)">
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import weather from '../../data/emer/weather.js'
export default {
  data() {
    return {
      fileList: [],
      type: '',
      fileName: ''
    }
  },
  created() {
    this.get_fileList()
  },
  methods: {
    // 获取文件列表
    get_fileList() {
      (async() => {
        let fileState = await weather.guidance_list({
          categories: '1,2,4'
        })
        if (fileState) {
          this.fileList = fileState.data
        }
      })()
    },
    comfirmButtype() {
      sessionStorage.typeNum = 1
      if(sessionStorage.itemName == 0) {
         this.$router.push('/Home')
         return
      }
      sessionStorage.BoxState = false
      this.$router.push('/Filedwed')
    },
    getFile(val) {
      if (!val) {
        this.$message.warning('文件获取失败,请稍后重试')
        return
      }
      window.location.href = `/api/emer/file/guidance/download?id=${val}`
    }
  }
}

</script>
<style lang="stylus" scoped>
.weather {
  width: 100%;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  .header {
    width
  }
  a {
    color: #1f2d3d;
    &:hover {
      color: #359eff;
    }
  }
  .header-top{
    margin-top:30px;
  }
}
.step {
  display: inline-block;
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  cursor: pointer;
}
.step:not(:last-child) {
  margin-right: 10px;
}
.step:hover .step-icon {
  color: red;
}
.step:hover .step-num span {
  background-color: red;
  box-shadow: none;
}
.step .step-con {
  width: 100%;
  height: auto;
  position: relative;
  margin-bottom: 10px;
  transition: all .3s ease-in-out;
}
.step .active {
  height: 60px;
}
.step-con .step-icon {
  width: 100%;
  height: 30px;
  margin-bottom: 10px;
  text-align: center;
  line-height: 30px;
  transition: all .3s ease-in-out;
}
.step-con .step-icon i {
  font-size: 30px;
}
.step-con .step-name {
  width: 100%;
  height: 20px;
  font-size: 14px;
  text-align: center;
  line-height: 20px;
  color: #373d41;
  transition: all .3s ease-in-out;
}
.step-con .step-num {
  height: 401px;
  width: 100%;
  position: absolute;
  bottom: -40px;
  text-align: center;
  z-index: 1;
}
.step-con .step-num span {
  transition: all .3s ease-in-out;
  display: block;
  margin: 10px calc((100% - 20px) / 2);
  height: 20px;
  width: 20px;
  border-radius: 10px;
  background: #373d41;
  line-height: 20px;
  text-align: center;
  font-size: 14px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// Weatherplan.vue?20ded8d3